// extracted by mini-css-extract-plugin
export var box = "tag-module--box--1YDrG";
export var title = "tag-module--title--7s2SK";